import { Button } from '@/components/ui/button'
import { FilterDropdown } from '@/components/ui/filter-dropdown'
import { reasonLabels } from './types'
import type { useUnmatchedItems } from './useUnmatchedItems'

export function QueueToolbar({
  state,
  selected,
  onIgnore,
  onClear,
}: {
  state: ReturnType<typeof useUnmatchedItems>
  selected: number
  onIgnore: () => void
  onClear: () => void
}) {
  return (
    <>
      <FilterDropdown
        label="Connection"
        emptyLabel="Connection"
        options={(state.rows.data?.connections ?? []).map((row) => ({
          value: String(row.id),
          label: row.display_name,
        }))}
        selected={state.connections}
        onChange={(value) => {
          onClear()
          state.setConnections(value)
        }}
      />
      <FilterDropdown
        label="Reason"
        emptyLabel="Reason"
        options={Object.entries(reasonLabels).map(([value, label]) => ({ value, label }))}
        selected={state.reasons}
        onChange={(value) => {
          onClear()
          state.setReasons(value)
        }}
      />
      <FilterDropdown
        label="Status"
        emptyLabel="Status"
        options={[
          { value: 'open', label: 'Open' },
          { value: 'ignored', label: 'Ignored' },
          { value: 'linked', label: 'Linked' },
        ]}
        selected={state.statuses}
        onChange={(value) => {
          onClear()
          state.setStatuses(value)
        }}
      />
      {selected > 0 && (
        <div className="flex h-9 basis-full items-center gap-3 rounded-md border border-border bg-muted/40 px-3 text-body-sm">
          <span>{selected} selected</span>
          <Button variant="outline" onClick={onIgnore}>
            Ignore {selected}
          </Button>
          <Button variant="ghost" onClick={onClear}>
            Clear
          </Button>
        </div>
      )}
    </>
  )
}
